import styled from 'styled-components'

export const PreviewContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp8};
`

export const Preview = styled.div`
  padding: ${props => props.theme.spacing.sp16};
  border-radius: ${props => props.theme.primitives.radius.radius1};
  background-color: #ffffff;
  opacity: 1;
  background-image:
    repeating-linear-gradient(45deg, lightgrey 25%, transparent 25%, transparent 75%, lightgrey 75%, lightgrey),
    repeating-linear-gradient(45deg, lightgrey 25%, #ffffff 25%, #ffffff 75%, lightgrey 75%, lightgrey);
  background-position:
    0 0,
    9px 9px;
  background-size: 18px 18px;
`
